import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { faImages } from "@fortawesome/free-solid-svg-icons";
import BasicButton from "../basics/BasicButton";
import { useAppSelector } from "../../store/hooks";
import { MINE_GALLERY_URL } from "../aotd-gallery/galleryFilters";

const Container = styled.section`
  width: 100%;
  border: 2px solid #273428;
  border-radius: 10px;
  padding: 16px;
  margin-top: 12px;
  background: #e5ffdf;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
`;

const Copy = styled.div`
  flex: 1 1 240px;
`;

const SectionTitle = styled.h3`
  margin: 0;
  color: #222;
`;

const Blurb = styled.p`
  margin: 4px 0 0 0;
  font-size: 0.9rem;
  color: #2d442f;
`;

/**
 * Shortcut from the profile to the AOTD gallery, pre-filtered to the days you
 * claimed. The gallery filters on the username in the session, so the panel
 * stays hidden until the session is restored and there is a username to
 * filter by — otherwise the link would land on an empty, confusing grid.
 */
const YourAotdsPanel: React.FC = () => {
  const navigate = useNavigate();
  const username = useAppSelector((state) => state.auth.username);
  const bootstrapStatus = useAppSelector((state) => state.auth.bootstrapStatus);

  if (bootstrapStatus !== "ready" || !username) return null;

  return (
    <Container>
      <Copy>
        <SectionTitle>Your AOTDs</SectionTitle>
        <Blurb>Every Art of the Day you claimed, in one place.</Blurb>
      </Copy>
      <BasicButton
        text="See your AOTDs"
        icon={faImages}
        bgColor="#a0d8f8"
        hoverBgColor="#7bc5f5"
        onClick={() => navigate(MINE_GALLERY_URL)}
      />
    </Container>
  );
};

export default YourAotdsPanel;
